import styled from 'styled-components';

export const PanelContainer = styled.div`
  width: 100%;
  margin: 50px 0;
`;

export const Panel = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 1100px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  h1 {
    font-size: 3rem;
    margin-bottom: 24px;
    font-family: 'Bossa Bold', sans-serif;
    color: ${(props) => props.theme.colors.violet500};
  }

  h2 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-size: 22px;
  }

  p {
    margin-bottom: 40px;
    font-size: 18px;
  }

  img {
    display: block;
    width: 100%;
    max-width: 500px;
    margin: 0 auto 24px;
    mix-blend-mode: multiply;
  }
`;

export const PanelCol = styled.div`
  width: 50%;
  position: relative;

  & + & {
    padding-left: 3rem;
  }

  img {
    width: 100%;
    max-width: 300px;
    margin: auto;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    width: 100%;

    & + & {
      padding-left: 0;
      margin-bottom: 5rem;
      text-align: center;
      order: -1;
    }

    img {
      max-width: 300px;
    }
  }
`;

export const Triangle = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  width: 100vw !important;
  max-width: 400px !important;

  @media ${(props) => props.theme.breakpoints.phone} {
    max-width: 80% !important;
  }
`;
